module.exports = __webpack_public_path__ + "img/trade.a8cf0fb3.svg";